import { Icon, Wordmark } from "./Icon.jsx";
// ─── MAINTENANCE PAGE ─────────────────────────────────────────────────────────
export function MaintenancePage({ message }) {
  return (
    <div style={{minHeight:"100vh",background:"var(--offwhite)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"40px 24px",textAlign:"center"}}>
      <div style={{maxWidth:480,width:"100%"}}>
        <div style={{marginBottom:24}}><Wordmark size={44}/></div>
        <div style={{fontSize:56,marginBottom:16}}><Icon n="settings" size={56} inline /></div>
        <h1 style={{fontSize:28,fontWeight:800,color:"var(--ink)",marginBottom:12,lineHeight:1.2}}>
          We'll be right back
        </h1>
        <p style={{fontSize:15,color:"var(--ink-soft)",lineHeight:1.6,marginBottom:32}}>
          {message || "Bloom is under scheduled maintenance. We're working on making things better — check back shortly."}
        </p>
        <div style={{background:"var(--lavender)",borderRadius:4,padding:"16px 24px",display:"inline-block"}}>
          <p style={{fontSize:13,fontWeight:700,color:"#5b4fcf",margin:0}}>bloomhq.in</p>
        </div>
      </div>
    </div>
  );
}
